import { axios } from '../utils/http'

// 首页接口
export const getIndexInfo = (params) => axios({
  method: 'GET',
  contentType: 'urlencoded'
}, '/index')

// 获取头部广告banner
export const getAdList = (params) => axios({
  method: 'GET',
  contentType: 'urlencoded'
}, '/ad/list?' + params)

// 获取赛题数据字典
export const getCompetitionDict = (params) => axios({
  method: 'GET',
  contentType: 'urlencoded'
}, '/competition/dict/list?' + params)

// 获取省份
export const getProvinceList = (params) => axios({
  method: 'GET',
  contentType: 'urlencoded'
}, '/area/provinceList')

// 获取城市
export const getCityList = (params) => axios({
  method: 'GET',
  contentType: 'urlencoded'
}, '/area/cityList?' + params)

// 获取根文章
export const getArticleByLevel = () => axios({
  method: 'GET',
  contentType: 'urlencoded'
}, '/article/listByLevel?')

// 文章接口
export const getArticle = (params) => axios({
  method: 'GET',
  contentType: 'urlencoded'
}, '/article/list?' + params)

// 获取单条文章
export const getArticleDetail = (params) => axios({
  method: 'GET',
  contentType: 'urlencoded'
}, '/article/detail?' + params)

// 获取文章树形列表
export const getArticleTreeList = (params) => axios({
  method: 'GET',
  contentType: 'urlencoded'
}, '/article/treeList?' + params)

// 添加订阅用户接口
export const addSubscription = (data) => axios({
  method: 'POST',
  contentType: 'json',
  data: data
}, '/subscription/add')

// 获取证书列表信息
export const getCertificates = (params) => axios({
  method: 'GET',
  contentType: 'urlencoded'
}, '/member/signup/getAward?recipientId=' + params)

// 获取开放原子大赛获奖队伍相关隐私声明
export const getPrivacyStatement = () => axios({
  method: 'GET',
  contentType: 'urlencoded'
}, '/article/privacyStatement')

